/**
 * Created by quikr on 12/9/16.
 */
import {beginAjaxCall} from "../ajaxStatusActions";
import _ApiCli from "../../../helpers/ApiCli";
import moment from 'moment';

let AjaxCall = new _ApiCli();


export function getEmployeeDetailsSuccess(employees) {
  return {type: 'GET_EMPLOYEE_DETAILS_SUCCESS', employees}
}

export function refreshEmployee(empId) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    let employees = getState().employeeDetails;
    let call1 = AjaxCall.asyncAction("/aboutEmpDetail?q=" + empId, 'get', null, null, dispatch);
    call1.then((response) => {

      let newEmployee = response.data.data;
      if (newEmployee.dateOfJoining != null && newEmployee.dateOfJoining != " ")
        newEmployee.dateOfJoining = moment(newEmployee.dateOfJoining).format("YYYY-MM-DD");


      let newEmployees = employees.map((node)=> {
        if (node.employeeCode == newEmployee.employeeCode)
          return newEmployee;
        else
          return node;
      });
      dispatch(getEmployeeDetailsSuccess(newEmployees));
    }).catch((error) => {
    });

  }

}


export function getEmployeeDetails() {

  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    let call1 = AjaxCall.asyncAction('/aboutEmpDetails', 'get', null, null, dispatch);
    call1.then((response) => {
      let employees = response.data.data;
      employees = employees.map((node)=> {
        if (node.dateOfJoining != null && node.dateOfJoining != " ")
          node.dateOfJoining = moment(node.dateOfJoining).format("YYYY-MM-DD");
         return node;
      });


      dispatch(getEmployeeDetailsSuccess(employees));
    }).catch((error) => {
    });

  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/Employee/employeeDetailActions.js
 **/